module.exports = __webpack_public_path__ + "media/images/icons/spinner-gray-6ed45beee3e97a769d4517f161a3f314.svg";